import { listAllNavCognitoGroups } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const fetchNavMenuForGroups = async (nextoken, limit=250) => {
  try {
    let gqlParams = {}
    if (nextoken!==undefined && nextoken!=='') {
      gqlParams = {
        allSort: "all",
        limit: limit,
        nextToken: nextoken
      }
    } else {
      gqlParams = {
        allSort: "all",
        limit: limit
      }
    }
    // console.log('gqlParams: ', gqlParams);

    const response = await client
    .graphql({
      query: listAllNavCognitoGroups,
      variables: gqlParams
    })
    // console.log('response: ', response);
    
    const results = response.data.allNavCognitoGroups

    return results;
  } catch (err) {
    return('fetchNavMenuForGroups error: ', [err]);
  }

}

fetchNavMenuForGroups.propTypes = {
  nextToken: PropTypes.string.isRequired,
  limit: PropTypes.string.isRequired,
};